import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../Context/AuthProvider';
import logo from './../assets/logo.svg'

const Header = () => {
  const { logOut, user } = useContext(AuthContext)

  const menuItems = <>
    <li>
      <Link className='font-semibold' to={'/'}>Home</Link>
      <Link className='font-semibold' to={'/service'}>service</Link>


    </li>
    {
      user?.uid ?
      <>
      <li>
        <Link className='font-semibold' to={'/orders'}>Orders</Link>
      </li>
      <li>
        <Link  to={'/login'}><button className="btn btn-ghost" onClick={logOut}>log Out</button></Link>
      </li>
      </>
      :
      <li>
        <Link className='font-semibold' to={'/login'}>Login</Link>
      </li>
    }

  </>

  return (
    <div>
      <div className="navbar h-20 pt-5 mb-12 text-black">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex={0} className="btn btn-ghost lg:hidden">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
            </label>
            <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
              {menuItems}
            </ul>
          </div>
          <Link to={'/'} className="btn btn-ghost normal-case text-xl">
            <img style={{ height: '40px' }} src="https://i.ibb.co/HBPPtdL/car-service-logo-2-F3-H.jpg" alt="" />
          </Link>
        </div>
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal p-0">
            {menuItems}
          </ul>
        </div>
        <div className="navbar-end">
          <button className="btn btn-outline btn-warning">Appointment</button>
        </div>
      </div>
    </div>
  );
};

export default Header;